import { FC } from "react";
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import { CreateRequestForm } from "./CreateRequestForm";

interface CreateRequestModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const CreateRequestModal: FC<CreateRequestModalProps> = ({ isOpen, onClose }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{"Create Document Request"}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={"1.5rem"}>
                    <CreateRequestForm onClose={onClose} />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
